module.exports = __webpack_public_path__ + "img/animals-in-order-blind.0ebcc42c.png";